export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const RES_PER_PAGE = 10;
